import * as React from "react";
const SvgCode = props => <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="m10.667 12 4-4-4-4M5.333 4l-4 4 4 4" /></svg>;
export default SvgCode;